export function canAccessExam(user, exam) {
  const access = user?.exam_access || 'both';
  return access === 'both' || access === exam;
}

export function getAllowedExam(user, preferredExam) {
  const access = user?.exam_access;
  return access === 'ielts' || access === 'pte' ? access : preferredExam;
}
